<template>
  <div class="load-hide bbh" style="text-align: center;padding-top: 40%;font-size:35px;color:#50a200;">
    错误
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
export default {
  data(){
      return{
        mid:"123",
        cb_url:'main.html#/main'
      }
  },
  mounted(){
//    window.location.href='http://postest.mc2113.cn:12500/static/weixin/login.html?mid='+this.mid+'&cb_url='+this.cb_url;
  },
  methods: {

  }
}
</script>

<style>

  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .bbh{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_bg.png);
    background-size: cover;
    text-align: center;
    height: 100%;
    overflow: hidden;
    position: relative;
    padding: 40% 13% 0;
  }
  .load-hide{
    height: 100%;
    background-color: #fff;

  }
  .button-one span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_vip.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 13.5px;
    height: 8.5px;
    display: inline-block;
  }

  .button-two span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_phone.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 10px;
    height: 13.5px;
    display: inline-block;
  }
  .button-three span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_shilden.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 10px;
    height: 12px;
    display: inline-block;
  }

  .success img{
    width: 247px;
  }

  .success-text p{
    margin-bottom: 3%;
  }
  .success-text input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 3px;
    margin-top: 2%;
    width:70%;
  }

  .fail img{
    width: 247px;
  }

  .fail-text p{
    margin-bottom: 3%;
  }
  .fail-text input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 3px;
    margin-top: 2%;
    width:70%;
  }
  .again img{
    width: 247px;
  }
  .again-text .pass{
    background:#356500 ;
    margin-top: 10px;
    letter-spacing: 3px;
  }
  .again input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
    margin-top: 2%;
    width: 70%;
  }

</style>



// WEBPACK FOOTER //
// gowhere.vue?27d1c905